import * as React from 'react';
import classNames from 'classnames';

export interface GridProps {
  id?: string;
  children?: React.ReactNode;
  className?: string;
}

const Grid: React.FunctionComponent<GridProps &
  React.HTMLAttributes<HTMLDivElement>> = (props: GridProps) => {
  const { id, children, className } = props;
  const gridClass = classNames(className, 'ui-grid');

  return (
    <div id={id} className={gridClass}>
      {children}
    </div>
  );
};

export default Grid;
